

module.exports = __webpack_require__.stylable.create(
    "Text2106135923",
    {"classes":{"root":"Text2106135923__root"},"vars":{},"stVars":{"titlesColor":"\"'color(--title-color)'\"","textsColor":"'\"color(--text-color)\"'","textsColorOpacity60":"'\"opacity(color(--text-color), 0.6)\"'","textsColorOpacity80":"'\"opacity(color(--text-color), 0.8)\"'","titlesFont":"'\"font(--title-font)\"'","textsFont":"'\"font(--text-font)\"'"},"keyframes":{}},
    "",
    3,
    "Text2106135923",
    null
);
